// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".first_form label[data-v-4ff4f55a]{font-weight:500}", ""]);
// Exports
module.exports = exports;
